import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, onSnapshot, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { useAuth } from '../AuthContext'; // <-- IMPORT MANCANTE
import { useTranslation } from 'react-i18next'; // <-- IMPORT MANCANTE
import ImageUploader from '../components/ImageUploader';
import './RoomDetailPage.css';

const RoomDetailPage = () => {
  const { roomId } = useParams();
  const navigate = useNavigate();
  const { currentUser } = useAuth(); // <-- DICHIARAZIONE MANCANTE
  const { i18n } = useTranslation(); // <-- DICHIARAZIONE MANCANTE
  const [roomData, setRoomData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    setLoading(true);
    setError(null);
    if (!roomId) { setError("ID camera mancante."); setLoading(false); return; }
    const docRef = doc(db, 'rooms', roomId);
    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setRoomData({ id: docSnap.id, ...data });
        const lang = i18n.language;
        const fallbackLang = 'it';
      } else {
        setError("Camera non trovata.");
      }
      setLoading(false);
    }, (err) => {
      setError("Errore nel caricamento dei dati della camera.");
      setLoading(false);
    });
    return () => unsubscribe();
  }, [roomId, i18n.language]);

  const handleImageUpdate = async (field, newUrl) => {
    if (!currentUser) return;
    const roomRef = doc(db, 'rooms', roomId);
    try {
        await setDoc(roomRef, { [field]: newUrl, updatedAt: serverTimestamp() }, { merge: true });
    } catch (error) {
        console.error("Errore aggiornamento immagine:", error);
        alert("Impossibile aggiornare l'immagine.");
    }
  };
  
  const handleDetailContentImageUpdate = async (index, newUrl) => {
      if (!currentUser || !roomData || !roomData.detailContent) return;
      // Crea una copia profonda per sicurezza
      const newContent = JSON.parse(JSON.stringify(roomData.detailContent));
      if (newContent[index]) {
          newContent[index].value = newUrl;
          await handleImageUpdate('detailContent', newContent);
      }
  };

  const handleCheckAvailability = () => {
    const lang = i18n.language;
    const fallbackLang = 'it';
    const name = roomData.name?.[lang] || roomData.name?.[fallbackLang] || '';
    navigate('/contatti', { state: { requestedRoom: name } });
  };

  const renderContent = () => {
    if (loading) return null;
    if (error) return <div className="container form-status error">{error}</div>;
    if (!roomData) return <div className="container no-content-text">Room data not available.</div>;
    
    const lang = i18n.language;
    const fallbackLang = 'it';
    const name = roomData.name?.[lang] || roomData.name?.[fallbackLang] || 'Dettaglio Camera';
    const shortDescription = roomData.shortDescription?.[lang] || roomData.shortDescription?.[fallbackLang] || 'Dettagli sulla camera';

    return (
      <div className="room-detail-page">
        <section className="page-header room-detail-header">
            <div className="container"><h1>{name}</h1></div>
        </section>
        <section className="content-section" style={{ paddingLeft: '5vw', paddingRight: '5vw' }}>
              <div className="main-detail-image-container">
                  {currentUser ? (
                      <ImageUploader currentImageUrl={roomData.imageUrl} onUploadComplete={(url) => handleImageUpdate('imageUrl', url)} folderPath="rooms/main"/>
                  ) : (
                      <img src={roomData.imageUrl || '/placeholder-image.jpg'} alt={`Immagine principale ${name}`} />
                  )}
                  <div className="image-overlay-description"><p>{shortDescription}</p></div>
              </div>
              <div className="dynamic-content-area">
                  {(roomData.detailContent || []).map((block, index) => {
                      const blockSize = block.size || (block.type === 'text' ? 'normal' : 'full');
                      const blockClass = `content-block ${block.type}-block size-${blockSize}`;
                      const key = block.blockId || index;

                      if (block.type === 'text') {
                          const text = block.value?.[lang] || block.value?.[fallbackLang] || "";
                          return (
                              <div key={key} className={blockClass}>
                                  {text.split('\n').map((line, i) => <p key={i}>{line || <> </>}</p>)}
                              </div>
                          );
                      }
                      if (block.type === 'image') {
                           return (
                              <div key={key} className={blockClass}>
                                  {currentUser ? (
                                      <ImageUploader currentImageUrl={block.value} onUploadComplete={(url) => handleDetailContentImageUpdate(index, url)} folderPath="rooms/details"/>
                                  ) : (
                                       <img src={block.value || '/placeholder-image.jpg'} alt={`Dettaglio ${name} ${index + 1}`} onError={(e) => { e.target.onerror = null; e.target.src='/placeholder-image.jpg'}}/>
                                  )}
                              </div>
                          );
                      }
                      return null;
                  })}
                  {(!roomData.detailContent || roomData.detailContent.length === 0) && (
                       <p className="no-content-text">(No additional details entered for this room)</p>
                  )}
              </div>

        </section>

        <section className="content-section" style={{ paddingTop: 0 }}>
            <div className="container">
              <div className="availability-button-container">
                  <button onClick={handleCheckAvailability} className="cta-button">{t('buttonCheckAvailability')}</button>
              </div>
            </div>
        </section>
      </div>
    );
  }

  return renderContent();
};

export default RoomDetailPage;


